export const SCREEN_SIZES = {
  mobile: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop',
};
